import Info from '@/pages/Info'

export default {
    path: '/info',
    name: 'Info',
    component: Info
}


// WEBPACK FOOTER //
// ./src/router/info.js